interface Props {
  height?: number | string
  radius?: number | string
}

export function ImagePlaceholder({ height = 240, radius = 3 }: Props) {
  return (
    <div
      style={{
        width: '100%',
        height,
        borderRadius: radius,
        background: '#171C22',
        backgroundImage: [
          'repeating-linear-gradient(45deg, #1E252C 0px, #1E252C 1px, transparent 1px, transparent 8px)',
          'repeating-linear-gradient(-45deg, #1E252C 0px, #1E252C 1px, transparent 1px, transparent 8px)',
        ].join(', '),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 18,
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: 88,
          height: 88,
          background: '#FFFFFF',
          borderRadius: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <img src="/logo.png" alt="Титан" style={{ width: 66, height: 66, objectFit: 'contain' }} />
      </div>
      <span style={{ color: '#FFFFFF', fontSize: 14, fontWeight: 700, letterSpacing: '.06em' }}>ООО «ТИТАН»</span>
    </div>
  )
}
